import moment from 'moment';
import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from '../controllers/secureStorage.js';

var pos_documentCustomFormat = {
  async print(endPoint, docId, isDefaultPrint, customFont){

    let component_x = {}
    component_x.endPoint = endPoint
    let pos_document = await HTTPRequest.getRequest(component_x.endPoint + "pos_documents/" + docId, null);
    let pos_document_lines = pos_document.details_pos_document_lines
    let pos_document_payments = pos_document.details_pos_document_payments
    
    let terminalName = pos_document.terminal_name
    let siteName = pos_document.site_name
    let siteAddress = pos_document.site_address
    let cashierName = pos_document.cashier_name
    let customerName = pos_document.customer_name
    let printDate = moment().format('lll') || '';
    let userCode = secureStorage.getItem("userCode") || '';
    let postDate = pos_document.created_at_formatted
    let salesman = pos_document.salesman_name
    let bagger = pos_document.bagger_name
    let transactionNumber = this.formatReceiptNumber({transactionNumber: pos_document.trans_id})
    let invoiceDate = pos_document.document_date
    let amountDue = parseFloat(pos_document.amount_due)
    let siOrNumber = pos_document.invoice_no
    let totalItemCount = parseInt(pos_document.total_quantity)
    let totalItemCountText = this.convertToCurrency(totalItemCount)
    let productList = pos_document_lines
    let totalExcess = pos_document_payments.reduce((sum, p) => sum + (parseFloat(p.excess) || 0), 0)
    if (totalExcess === 0 && pos_document_payments.length > 0) {
      // Fallback: calculate change from total tender minus amount due
      let totalTender = pos_document_payments.reduce((sum, p) => sum + (parseFloat(p.amount_tender) || 0), 0)
      let computedChange = totalTender - parseFloat(pos_document.amount_due)
      if (computedChange > 0) totalExcess = computedChange
    }
    let changeText = this.parseToFinalFormat(totalExcess)
    let vatableSales = parseFloat(pos_document.amount_gross_vat)
    let vatableSalesText = this.parseToFinalFormat(vatableSales)
    let totalLessVat = parseFloat(pos_document.totalLessVat)
    let totalLessVatText = this.parseToFinalFormat(totalLessVat)
    let vatAmount = parseFloat(pos_document.amount_tax)
    let vatAmountText = vatAmount > 0 ? this.parseToFinalFormat(vatAmount) : "0.00"
    let totalGrossAmount = parseFloat(pos_document.amount_gross)
    let totalGrossAmountText = this.parseToFinalFormat(totalGrossAmount)
    let totalItemDiscountAmount = parseFloat(pos_document.amount_item_discount)
    let totalNetItemDiscountAmount = Number(totalGrossAmount) - Number(totalItemDiscountAmount)
    let totalNetItemDiscountAmountText = this.parseToFinalFormat(totalNetItemDiscountAmount)
    let totalQuantity = this.parseToFinalFormat(pos_document.total_quantity)
    

    let defaultCharacterLength = 42
    let maxCharacterLength = 40 // (PRINTER.MAX_CHARACTER_LENGTH))
    let amountAndCountSpace = maxCharacterLength - defaultCharacterLength
    let countLessSpace = 0 // For spacing format
    let amountLessSpace = 0 // For spacing format
    let textToAppend = "\n\n"
    let logFileExtension = ".txt"
    let longestAmountLength = 0
    let spacesToAdd = 0
    let terminalTransactionType = "POS DOCUMENT"
    let productTaxTypeLength = 2
    
    if (amountAndCountSpace != 0) {
      let spacesToSplit = amountAndCountSpace / 2;
      if (spacesToSplit.toString().includes(".")) {
        // if may remainder priority to add space to amount than count text
        countLessSpace = parseInt(spacesToSplit.toString().split(".")[0]);
        amountLessSpace = parseInt(spacesToSplit.toString().split(".")[0]);
        if (amountAndCountSpace > 0) countLessSpace++;
        else amountLessSpace--;
      } else {
        countLessSpace = spacesToSplit;
        amountLessSpace = spacesToSplit;
      }
    }

    if(pos_document_payments.length > 0){
      pos_document_payments.forEach((payment) => {
        let samePayments = pos_document_payments.filter((p) => {
          return p.type == payment.type;
        });
  
        let amountLength = this.parseToFinalFormat(payment.tender).length;
  
        if (samePayments.length > 1) {
          let totalPaymentTender = 0;
          samePayments.forEach((sp) => {
            totalPaymentTender += parseFloat(sp.tender);
          });
          amountLength = this.parseToFinalFormat(totalPaymentTender).length;
        }
  
        if (amountLength > longestAmountLength) {
          longestAmountLength = amountLength;
          spacesToAdd =
            12 +
            (this.parseToFinalFormat(payment.tender).length -
              this.parseToFinalFormat(amountDue).length);
        } 
      });
    } else {
      console.log('else')
      spacesToAdd = 8
    }
    console.log('spacesToAdd')
    console.log(spacesToAdd)
    // header details
    textToAppend +=
      "" +
      `\n${this.alignToReceipt("ct", siteName)}` +
      `\n${this.alignToReceipt("ct", siteAddress || "")}` +
      `\n${this.alignToReceipt("ct", terminalTransactionType)}` +
      `\nTerminal: ${terminalName}` +
      `\nTrans #: ${transactionNumber}${this.addSpace(
        maxCharacterLength -
          6 -
          transactionNumber.length -
          this.formatDate(invoiceDate, "MM/DD/YYYY").length
      )}${this.formatDate(invoiceDate, "MM/DD/YYYY")}` +
      `\nOR/SI #   : ${siOrNumber}${this.addSpace(
        maxCharacterLength -
          11 -
          siOrNumber.length -
          this.formatDate(invoiceDate, "hh:mm A").length
      )}${this.formatDate(invoiceDate, "hh:mm A")}` +
      `\nCashier : ${ cashierName
      }`
        "" +
        "";
    textToAppend += `\n${"-".repeat(maxCharacterLength)}`;

    // product details
    productList.forEach((product) => {
      let quantity = product.quantity
      let regularPrice = parseFloat(product.price)
      // let regularPriceText = this.parseToFinalFormat(regularPrice * parseFloat(quantity)) // Net
        
      let price = parseFloat(product.price)
      let priceText = this.parseToFinalFormat(price, 4) // Per piece
      let totalPriceToShow = this.parseToFinalFormat(parseFloat(product.subtotal)) // Total Gross Price
      // let discountText = 'product.discount_text'
      let discountAmount = parseFloat(product.discount_amount1)
      // let discountAmountText = this.parseToFinalFormat(discountAmount) // Net
      let productTaxType = ` ${product.tax_type}`;

      priceText = this.parseToFinalFormat(price, 4);

      if (quantity.split(".")[1] == "0")
        quantity = quantity.split(".")[0];
      else quantity = this.parseToFinalFormat(quantity, 2);

      let unitToUse;

      textToAppend +=
        `\n${ product.barcode 
        } ${product.description}` +
        `\n   ${quantity} ${
          unitToUse != undefined
            ? unitToUse 
            : parseFloat(quantity) == 1
            ? "pc"
            : "pcs" // Use default
        } x ${priceText}${this.addSpace(
          maxCharacterLength -11 -
            quantity.length -
            priceText.length -
            (totalPriceToShow.length + 1) +
            (parseFloat(quantity) == 1 ? 1 : 0) // For (s) in pcs
        )}${totalPriceToShow}${productTaxType}`;
    });

    textToAppend +=
      `\n${"-".repeat(maxCharacterLength)}` +
      "\n" +
      `   ${totalItemCountText} Item(s)${this.addSpace(
        maxCharacterLength -
          3 - // Pre-space
          8 - // Item(s)
          productTaxTypeLength - // Item type space
          totalItemCountText.length -
          totalNetItemDiscountAmountText.length
      )}${totalNetItemDiscountAmountText}${this.addSpace(
          productTaxTypeLength
      )}`;
            
    // totals 
    textToAppend +=
      `\n${this.alignToReceipt("rt", "-".repeat(13))}` +
        "\n" ;
    textToAppend +=
    this.alignToReceipt(
      "rt",
      `AMOUNT GROSS:${this.addSpace(
        spacesToAdd -
          productTaxTypeLength +
          (totalGrossAmountText.length -
              this.parseToFinalFormat(totalGrossAmount).length)
      )}${this.parseToFinalFormat(totalGrossAmount)}${this.addSpace(
        productTaxTypeLength
      )}`
    ) +
    "\n"; 
    if(totalItemDiscountAmount > 0){
      textToAppend +=
      this.alignToReceipt(
        "rt",
        `DISCOUNT:${this.addSpace(
          spacesToAdd -
            productTaxTypeLength +
            (totalNetItemDiscountAmountText.length -
                this.parseToFinalFormat(totalItemDiscountAmount).length)
        )}${this.parseToFinalFormat(totalItemDiscountAmount)}${this.addSpace(
          productTaxTypeLength
        )}`
      ) +
    "\n" ;
    }
        
    textToAppend +=
    this.alignToReceipt(
      "rt",
      `AMOUNT DUE:${this.addSpace(
        spacesToAdd -
          productTaxTypeLength +
          (totalNetItemDiscountAmountText.length -
              this.parseToFinalFormat(amountDue).length)
      )}${this.parseToFinalFormat(amountDue)}${this.addSpace(
        productTaxTypeLength
      )}`
    );
    
    // payments
    pos_document_payments.forEach((payment) => {
      let paymentTenderAmount = this.parseToFinalFormat(payment.amount_tender);
      let samePayments = pos_document_payments.filter((p) => {
        return p.type == payment.type;
      });

      if (samePayments.length > 1) {
        let totalPaymentTender = 0;
        samePayments.forEach((sp) => {
          totalPaymentTender += parseFloat(sp.amount_tender);
        });
        paymentTenderAmount = this.parseToFinalFormat(totalPaymentTender);
      }

      let paymentLineText = `${payment.type}:${this.addSpace(
        spacesToAdd -
          productTaxTypeLength +
          (totalGrossAmountText.length - paymentTenderAmount.length)
      )}${paymentTenderAmount}${this.addSpace(productTaxTypeLength)}`;

      if (
        paymentLineText.length >=
        maxCharacterLength - productTaxTypeLength - spacesToAdd
      ) {
        paymentLineText = `${paymentTenderAmount}${this.addSpace(
          productTaxTypeLength
        )}`; // Get only the amount and space

        textToAppend +=
          "\n" +
          `${payment.type}:` +
          "\n" +
          this.alignToReceipt("rt", paymentLineText);
      } else
        textToAppend += "\n" + this.alignToReceipt("rt", paymentLineText);
    });

    
    textToAppend +=
      `\n` +
      this.alignToReceipt("rt", `${"-".repeat(13)}`) +
      `\n` +
      this.alignToReceipt(
        "rt",
        `CHANGE:${this.addSpace(
          spacesToAdd -
            productTaxTypeLength +
            (totalNetItemDiscountAmountText.length - changeText.length)
        )}${changeText}${this.addSpace(productTaxTypeLength)}`
      ) +
      `\n` +
      `\nTOTAL QUANTITY   : ${this.addSpace(
        maxCharacterLength - 30 - totalQuantity.length
      )}${totalQuantity}`  +
      `\nNET AMOUNT       : ${this.addSpace(
        maxCharacterLength - 30 - totalNetItemDiscountAmountText.length
      )}${totalNetItemDiscountAmountText}` +
      `\nVAT AMOUNT       : ${this.addSpace(
        maxCharacterLength - 30 - vatAmountText.length
      )}${vatAmountText}` +
      `\nTOTAL WITH VAT   : ${this.addSpace(
        maxCharacterLength - 30 - totalGrossAmountText.length
      )}${totalGrossAmountText}` +
      `\n` +
      `\nBagger : ${bagger || ""}` +
      `\nSalesman : ${salesman || ""}` +
      `\nCustomer : ${customerName || ""}` +
      `\n` +

      // footer
      `\nPosted By : ${cashierName || ""}` +
      `\nPost Date : ${postDate || ""}` +
      `\nPrinted By : ${userCode || ""}` +
      `\nPrinted Date : ${printDate || ""}`;
    textToAppend += `\n`;

    // call function print here
    this.createFile(textToAppend, transactionNumber, logFileExtension)

  }, // end of print
    
  // more methods
  parseToFinalFormat(num, scale){
      return num.toFixed(scale).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  },
  alignToReceipt(align, textToAlign) {
      let maxCharacterLength = 40
      switch (align) {
        case "ct":
          return `${this.addSpace(
            (maxCharacterLength - textToAlign.length) / 2
          )}${textToAlign}`;
        case "rt":
          return `${this.addSpace(
            maxCharacterLength - textToAlign.length
          )}${textToAlign}`;
        case "maxLength":
          // Create a string separated by newline when it exceeds maxCharacterLength
          // 1. Split the string into parts based on the value of maxCharacterLength
          // 2. Parts will be stored in array.
          // 3. Join the array using newline
          if (textToAlign) {
            let regexPattern = new RegExp(`.{1,${maxCharacterLength}}`, "g");
            let result = textToAlign.match(regexPattern) || [];
            return result.join("\n");
          } else {
            return textToAlign;
          }
    
        default:
          return textToAlign;
      }
  },
  addSpace(count) {
    try {
      return " ".repeat(count);
    } catch (err) {
      return " ".repeat(0);
    }
  },
  parseToFinalFormat(number = 0) {
    if (number == null) number = 0;
    return this.formatNumberToCurrency(this.roundNumber(parseFloat(number) + 0.0000001, 2)); // Add 0.0000001 to round up >= 5.
  },
  formatNumberToCurrency(number) {
    let stringNumber = this.convertToCurrency(number, 2);
    if (!stringNumber.includes(".")) return `${stringNumber}.00`;
    else if (stringNumber.split(".")[1].length == 1) return `${stringNumber}0`;
    else return stringNumber;
  },
  roundNumber(number, nearestDecimal) {
    return parseFloat((parseFloat(number) + 0.0000001).toFixed(nearestDecimal));
  },
  formatDate(date = "", format = "YYYY-MM-DD") {
    return moment(date).format(format);
  },
  convertToCurrency(num, scale){
    return num.toFixed(scale).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  },
  formatReceiptNumber(data = {}) {
    let transactionNumberLength = 10
    let transactionNumber = parseInt(data.transactionNumber) || 0;
  
    return `${"0".repeat(
      transactionNumberLength - transactionNumber.toString().length
    )}${transactionNumber}`;
  },
  createFile(text, transId, logFileExtension){
    const blob = new Blob([text], { type: 'text/plain' });

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Trans#${transId}_${moment().format("YYYY_MM_DD")}${logFileExtension}`;

    // Trigger the download
    link.click();

    // Clean up
    URL.revokeObjectURL(link.href);
  },
}

export default pos_documentCustomFormat;